export const pageTitle = title => {
  return (document.title =
    title + ' -  Sam Health Care - Quality Medicine Manufacturing');
};
